import R from 'ramda'

const FACEBOOK_RECURRING_OPTIN_WIDGET_TYPE = 'FB_OPT_IN_RECURRING'
const FACEBOOK_RECURRING_OPTIN_DISPLAY_TYPE = 'Opt FB User in - Recurring'

const isFacebookRecurringWidgetOptInAction = R.propEq(
  'type',
  FACEBOOK_RECURRING_OPTIN_WIDGET_TYPE
)

const convertFacebookRecurringOptInToFormAction = R.applySpec({
  type: R.always(FACEBOOK_RECURRING_OPTIN_DISPLAY_TYPE)
})

export {
  isFacebookRecurringWidgetOptInAction,
  convertFacebookRecurringOptInToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/widget-to-form/facebook-recurring-optin.js